import '@/assets/reset.css'

import Vue from 'vue'
import App from './App.vue'

import _ from 'underscore'
import axios from 'axios'
import autogrow from 'vue-textarea-autogrow-directive'

import router from './router'
import store from './store'

import mixInjection from './mixin/injection'
import mixShortcuts from './mixin/shortcuts'

axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.baseURL = 'https://api.virtual.alzheimer.staging.exesios.com/api/'

var requireComponentGlobal = require.context('./components/common', true, /[A-Z]\w+\.(vue|js)$/)

requireComponentGlobal.keys().forEach(function(filename) {

	var componentConfig = requireComponentGlobal(filename)
	var componentName = 'a' + filename.replace(/\//g, '-').replace('.vue', '').replace('.', '').toLowerCase()

	Vue.component(
		componentName,
		componentConfig.default
	)

})

Vue.config.productionTip = false

Vue.use(autogrow)

Vue.mixin(mixInjection)
Vue.mixin(mixShortcuts)

new Vue({
	router,
	_,
	store,
	render: h => h(App)
}).$mount('#app')
